const articles = [
  {
    name: "login",
    title: "Login Awal web apps",
    desc: "Login Untuk memulai aplikasi kasir toko online",
    img:
      "https://1.bp.blogspot.com/-n0IO8Jdh9d4/YDIb5_uqzAI/AAAAAAAANAo/DKs8fBcQ3esRmuQSfxNFne2rWWVWcRlDQCLcBGAsYHQ/s615/login.png",
    content: [
      `Fitur login untuk akses web vpos ini diproteksi dengan keamanan user name dan password.`,
      `Selanjutnya untuk akses wajib memasukan username dan password yang sudah didaftarkan pada aplikasi mesin kasir online toko ini.`
    ]
  },
  {
    name: "dashboard",
    img:
      "https://1.bp.blogspot.com/-tMgCEKEyo4Q/YDIKeQ-o86I/AAAAAAAAM_0/-krKQGU1zDY9YJJSXXfdcfiN0f6HbfMjgCLcBGAsYHQ/s1352/1home.png",
    title: "Dashboard menu",
    desc: "Ruang kerja dan menu utama aplikasi mesin kasir online toko",
    content: [
      `Setelah sukses melakukan login maka selanjutnya aplikasi akan membawa anda ke halaman dashboard menu untuk mulai beraktifitas dan bekerja menggunakan toko apps vpos.`,
      `Langkah awal untuk penggunaan adalah dengan menggunakan fitur menu secara berurutan dari kiri ke kanan.`
    ]
  },
  {
    name: "user",
    title: "User Pengguna",
    img:
      "https://1.bp.blogspot.com/-VS-0-bna7nU/YDIKeNn-bhI/AAAAAAAAM_w/mlvnieLpCr0i0hw6n6BFSFxjpz3Gth3nwCLcBGAsYHQ/s1358/2user.png",
    desc: "Regristasi user pengguna aplikasi toko",
    content: [
      `Selanjutnya kita bisa mendaftarkan staff kita pada menu ini, dimenu ini kita bisa memasukan nama pengguna atau karyawan include dengan password untuk proteksi login menggunakan vpos web apps ini.`
    ]
  },
  {
    name: "grup",
    title: "Group Product",
    img:
      "https://1.bp.blogspot.com/-nkEGsnXuEuk/YDIKfBKPIiI/AAAAAAAAM_4/Shwu5AbRBxYILo7ZtKBIfS91K1LAaVbaACLcBGAsYHQ/s1356/3group.png",
    desc: "Grouping dan kategori pengelompokan produk jual",
    content: [
      `Dan untuk kemudahan pengelompokan maka hadir grup dan kategori untuk memudahkan dalam melakukan pengelompokan dan pencarian produk berdasarkan grup nya.`
    ]
  },
  {
    name: "satuan",
    title: "Unit Satuan Produk",
    img:
      "https://1.bp.blogspot.com/-ASvVQON3Uv8/YDIKfF8B7SI/AAAAAAAAM_8/4k9UVATH6i8ii8B5f9Yq_jCwWLzEW_F5wCLcBGAsYHQ/s1342/4unit.png",
    desc: "Satuan unit berdasarkan produk",
    content: [
      `Pada setiap produk memiliki satuan yang berbeda beda bukan, maka untuk kemudahan itu sudah tersedia master satuan unit untuk membuat satuan berdasarkan kebutuhan anda, misal pcs, box, pak , kg , litter dan lain lain.`
    ]
  },
  {
    name: "product",
    title: "Produk Jual",
    img:
      "https://1.bp.blogspot.com/-qnK9jvqw85E/YDIKfsFQ24I/AAAAAAAANAA/IusqLO3GTIg0cowh6MmEUVUINwWLn_FBgCLcBGAsYHQ/s882/5product.png",
    desc: "Produk produk untuk dijual dan transaksi pada kasir",
    content: [
      `Setelah pengisian satuan dan grup sudah selesai maka kini kita bisa melakukan dan mendaftarkan produk produk jual kita pada menu ini, support dengan barcode kode, harga beli dan harga jual lengkap tersedia pada menu ini.`
    ]
  },
  {
    name: "inventori",
    title: "Inventori Management",
    img:
      "https://1.bp.blogspot.com/-RK6eN0BJyug/YDIKgXtMbMI/AAAAAAAANAE/4wvrwU47AXA--ivXuiQkZeXKZxMm5YWjgCLcBGAsYHQ/s1356/6inventori.png",
    desc: "Stok inventori untuk kebutuhan stok stok produk",
    content: [
      `Dan untuk kemudahan inventori management disini sudah tersedia fitur untuk melakukan dan mencatat transaksi stok guna mengisi maupun menambah stok inventori pada fitur ini, tinggal masukan qty untuk melakukan penambahan stok , maka secara otomatis aplikasi akan menambahkan stok baru ke stok awal yang dimiliki.`
    ]
  },
  {
    name: "pointofsale",
    title: "POS Penjualan kasir",
    img:
      "https://1.bp.blogspot.com/-mnfcq8GA1oo/YDIKgsFM-lI/AAAAAAAANAI/ZSRgTZinRusnAmptoM5y7BAgkGd1LfpzACLcBGAsYHQ/s1322/7pos.png",
    desc: "Menu penjualan kasir point of sale",
    content: [
      `POS system adalah fitur untuk melakukan transaksi dan mencatat penjualan kepada pelanggan, klik pada menu kasir pos penjualan dan mulai bekerja dengan barcode dan printer kasir untuk mencetak struk kasir bukti penjualan kepada pelanggan.`
    ]
  },
  {
    name: "laporan",
    title: "Laporan detail",
    img:
      "https://1.bp.blogspot.com/-vxqh5_XwSPI/YDIKhGnvgaI/AAAAAAAANAM/iWUBkUWTsTcaSeOzsa_La0cnqTNLiVPEQCLcBGAsYHQ/s1338/8.list%2Bpenjualan%2Bkasir.png",
    desc: "Laporan detail transaksi list penjualan income",
    content: [
      `Dan untuk cek laporan transaksi pada kasir sudah hadir pada menu laporan ini untuk kemudahan kontrol dan monitoring kebutuhan untuk cek laporan penjualan disini.`
    ]
  },
  {
    name: "backoffice",
    title: "Fitur Backoffice Admin",
    img:
      "https://1.bp.blogspot.com/-Cgn4KFLnZuo/YDIKh2e8SCI/AAAAAAAANAQ/xFytD_5SJs8ku_Gn5oHazcVmF05dgJ7NgCLcBGAsYHQ/s1349/9.laporan%2Badmin.png",
    desc: "Backoffice admin untuk cek seluruh laporan laporan detail",
    content: [
      `Dan kini hadir menu laporan detail backoffice fitur untuk kebutuhan admin cek kebutuhan pedapatan hari ini, pendapatan kemarin dan lain lain tersedia untuk monitoring pembukuan pada toko.`
    ]
  }
];

export default articles;
